// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"f71cad1c","312":"60d662c6","484":"ec09f80b","551":"cfcc5244"}[chunkId] + ".chunk.js";
};